var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white-border pa-2 rounded-lg",staticStyle:{"width":"inherit","color":"#fff"},attrs:{"depressed":"","color":"#3c3c3c"},on:{"click":function($event){return _vm.$emit('handleClickClearButton')}}},[_vm._t("text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }